import { useState } from 'react';
import useApiFetch from '@/hooks/useApiFetch';
import compensationService from '@/services/compensation';
import { FetchApiIds } from '@/types';
import StaffMemberCompensationSectionComponent, {
  Props as StaffMemberCompensationSectionComponentProps,
} from './StaffMemberCompensationSection.component';

type Props = Pick<StaffMemberCompensationSectionComponentProps, 'id'> & {
  staffMemberId: string;
};

const StaffMemberCompensationSection = ({ staffMemberId, ...props }: Props): JSX.Element => {
  const [isEditing, setIsEditing] = useState<Record<string, boolean>>({});
  const [isAdding, setIsAdding] = useState<boolean>(false);

  const handleAddClick = (): void => {
    setIsAdding?.(true);
  };

  const { data: compensations, refetch: refreshCompensations } = useApiFetch(
    [FetchApiIds.GET_COMPENSATIONS, staffMemberId],
    async () => compensationService.listCompensations(staffMemberId)
  );

  return (
    <StaffMemberCompensationSectionComponent
      staffMemberId={staffMemberId}
      isEditingMap={isEditing}
      onEditClick={(id) => setIsEditing((map) => ({ ...map, [id]: true }))}
      onEditComplete={(id) => setIsEditing((map) => ({ ...map, [id]: false }))}
      compensations={compensations}
      isAdding={isAdding}
      onAddClick={handleAddClick}
      refreshCompensations={refreshCompensations}
      setIsAdding={setIsAdding}
      {...props}
    />
  );
};

export default StaffMemberCompensationSection;
